import Index from '../../views/query/Index.vue';
import Batch from '../../views/query/Batch.vue';

export default [
  {
    path: '/query',
    name: 'query',
    component: Index,
    meta: {
      can: 'view query',
      breadcrumb: [
        { name: '一般查證', route: "query" }
      ]
    }
  },
  {
    path: '/batch',
    name: 'batch',
    component: Batch,
    meta: {
      can: 'view batch',
      breadcrumb: [
        { name: '大量查證', route: "batch" }
      ]
    }
  }
]
